module.exports = __webpack_public_path__ + "static/media/in-love.1f233040.png";